import { handleActions } from 'redux-actions';
import { ResultState } from '../constants/model';
import Immutable from 'immutable';

const resultReducer = handleActions({
    SET_RESULTVALUE : (state, { payload })=>{
        return state.set( 'result', Immutable.fromJS(payload.value))
    },
    

}, ResultState)

export default resultReducer